import Starling from "@ies/starling_client";
class StarlingClientBackend {
  init(_, backendOptions = {}, allOptions) {
    const { solution, fallbackLng } = allOptions;
    const { namespaces, apiZoneHost } = solution;
    const fallbackLangs = fallbackLng ? typeof fallbackLng === "string" ? [
      fallbackLng
    ] : fallbackLng : [];
    namespaces.forEach((project) => {
      const { apiKey, spaceName } = project;
      this._starlingClients[spaceName] = new Starling({
        apiKey,
        namespace: [
          spaceName
        ],
        zoneHost: apiZoneHost ? apiZoneHost : "https://starling-sg.tiktokv.com",
        lazyUpdate: true,
        format: "splitted",
        fallbackLang: fallbackLangs,
        ...backendOptions
      });
    });
  }
  read(language, namespace, callback) {
    this._doRead(language, namespace, callback);
  }
  _doRead(language, namespace, callback) {
    const starling = this._starlingClients[namespace];
    starling.setConfig({
      locale: language
    });
    starling.load((texts) => callback(null, texts[namespace].texts)).catch((err) => callback(err, {}));
  }
  constructor() {
    this.type = "backend";
    this._starlingClients = {};
  }
}
StarlingClientBackend.type = "backend";
export {
  StarlingClientBackend
};

//# sourceMappingURL=starling-api.browser.js.map